// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/face-mouthopen-outline.svg';

export const FaceMouthOpenOutline = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
